import { render, staticRenderFns } from "./CommSupporter.vue?vue&type=template&id=15a5dea8&scoped=true&"
import script from "./CommSupporter.vue?vue&type=script&lang=js&"
export * from "./CommSupporter.vue?vue&type=script&lang=js&"
import style0 from "./CommSupporter.vue?vue&type=style&index=0&id=15a5dea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5dea8",
  null
  
)

export default component.exports